import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SelectPicker, Stack } from 'rsuite';
import { setEmptyTemplateHtml, updatePrescriptionType } from '../Redux/Slice/rootSlice';

function TemplateSelect(props) {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('');
  const dispatch = useDispatch();
  const closeUserPopup = e => {
    props.setTypeTemplatePopUp(false);
  };
  const handleDropChanges = e => {
    dispatch(setEmptyTemplateHtml(''));
    setSelectedType(e);
  };
  const handleSubmit = () => {
    dispatch(updatePrescriptionType(selectedType));
    navigate('/prescription');
  };

  const data = [
    'ART Summary',
    'Booking Visit',
    'Egg Collection Instructions',
    'Empty Page',
    'Fertility First Visit',
    'Irregular Periods',
    'Stimulation Template',
    'Planning Summary',
    'Post Egg Collection Prescription',
    'Pre OP Check List',
    'Post P4 Prescription',
    'SC-FET Stimulated Cycle',
    'HRT Chart',
    'HRT Check List',
    'Spontaneous Pregnancy - 2 Month',
    'Spontaneous Pregnancy - 3 Month',
    'Spontaneous Pregnancy - 4 Month',
    'Spontaneous Pregnancy - 5 Month',
    'Spontaneous Pregnancy - 6 Month',
    'Spontaneous Pregnancy - 7 Month',
    'Spontaneous Pregnancy - 8 Month',
    'Spontaneous Pregnancy - 9 Month',
    'Positive Prescription Basic',
    'Positive Prescription Advanced',
    'Post Natal',
    'Post IUI Sheet',
    'ICSI 2 nd month(1 st Scan)',
    'ICSI 2 nd month(8 Weeks Scan)',
    'ICSI 2 nd month(10 Weeks Scan)',
    'ICSI 3 rd Month',
    'ICSI 4 th Month',
    'ICSI 5 th Month',
    'ICSI 6 th Month',
    'ICSI 7 th Month',
    'ICSI 8 th Month',
    'ICSI 9 th Month',
    'Negative IVF Cycle Analysis',
    'IUI Chart',
    'OI TIC',
    // 'DONOR STIMULATION CHECK LIST',
    // 'Bp Sugar Chart',
    // 'Blood Pressure Chart',
    // 'Kick Count Chart',
    'Preterm Labour',
    // 'Scan Module'
  ]
    .map(item => ({label: item, value: item}))
    .sort((a, b) => a.label.localeCompare(b.label));
  return (
    <>
      <div className='adminform' style={{alignItems: 'start'}}>
        <div class='modal-dialog1' role='document'>
          <div class='modal-content modelContentChanges'>
            <div class='modal-header'>
              <h5 class='modal-title'>Template</h5>
              <button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={e => closeUserPopup(e)}>
                <i class='bi bi-x-lg'></i>
              </button>
            </div>
            <div class='modal-body modelBodyChanges' style={{padding: '1rem', width: '520px'}}>
              <div className='row'>
                <div className='col-12'>
                  <p>Select type of Template</p>
                </div>
                <div class='col-12 title-dropdown'>
                  <Stack spacing={10} direction='column' alignItems='flex-start'>
                    <SelectPicker data={data} style={{width: 300}} onChange={e => handleDropChanges(e)} />
                  </Stack>
                </div>
              </div>
            </div>
            <div class='modal-footer modelBodyChanges' style={{padding: '1rem', width: '520px'}}>
              <button onClick={handleSubmit} className='submitPrescriptionTypebtn' disabled={selectedType !== '' ? false : true}>
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TemplateSelect;
